module.exports = __webpack_public_path__ + "img/nzavo-img.e32af944.jpg";